import type { Booking } from '@/entities/bookings/booking.entity.ts';
import { InvoicingType } from '@/entities/bookings/invoicing-type.enum';

export function getInvoicingPolicy(booking: Booking) {
  const payer =
    booking.invoicingType === InvoicingType.INSURANCE
      ? 'paidByInsurance'
      : booking.invoicingType === InvoicingType.AGENCY ||
          booking.invoicingType === InvoicingType.AGENCY_BULK
        ? 'paidByAgency'
        : null;
  return {
    hidePricesText: payer,
    hidePrices: payer !== null,
    canChangeRange: payer !== 'paidByAgency',
    shouldShowExtrasUpgrade: !booking.insuranceCase,
    extrasImmutable: false,
    customerHasToPay:
      booking.invoicingType === InvoicingType.REGULAR ||
      booking.invoicingType === InvoicingType.COMMISSION ||
      booking.invoicingType === InvoicingType.COMPANY_REGULAR,
  };
}
